import { AxiosRequestConfigMethods } from "@/api/types";
import { brandUrl } from "@/api/utils";
import { fetchFromBrandedUrl } from "@/api/utils";
import { EnvironmentVariables } from "@/modules/common/types";
import {
  LeadTag,
  LeadTagsResponse,
  UpdateLeadTag,
  AddLeadTag,
} from "@/modules/lead-tags/dtos";
import { BasePaginationParams } from "@/modules/common/dtos/index.v2";

export const getLeadTags = async (
  pagination: BasePaginationParams,
  searchTerm?: string
) => {
  const apiUrl = brandUrl<LeadTagsResponse>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/lead-tags`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      params: {
        ...pagination,
        ...(searchTerm?.trim() !== "" && { name: searchTerm }),
      },
    },
  }) as Promise<{ data: LeadTagsResponse }>;
};

export const updateLeadTag = async (id: string, data: UpdateLeadTag) => {
  const apiUrl = brandUrl<LeadTag>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/lead-tags/${id}`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.PATCH,
      data: data,
    },
  });
};

export const createLeadTag = async (data: AddLeadTag) => {
  const apiUrl = brandUrl<LeadTag>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/lead-tags`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.POST,
      data: data,
    },
  });
};

export const deleteLeadTag = async (id: string) => {
  const apiUrl = brandUrl<LeadTag>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/lead-tags/${id}`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.DELETE,
    },
  });
};
